export enum JobActionType {
  StartJob,
  StopJob,
  ReworkJob,
  CompleteJob,
  CompleteProductionOrder,
  JobsReloaded,
  ImportFailed
}
